import './v2-base.js';
import { initRunnerAnchor } from '../../static/racing/js/v2/runner_anchor.js';

if (document.querySelector('.race-page')) {
  initRunnerAnchor();
  window.addEventListener('hashchange', () => initRunnerAnchor());
}
